import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./b24Slice";

const RequireAuth = () => {
    const token = useSelector(selectCurrentToken);
    const location = useLocation();

    return (
        token
            ? <Outlet />
            : <Navigate to="/b24/signin" state={{ from: location }} replace />
    );
}

export default RequireAuth;